import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { I18n } from 'react-redux-i18n';
import MsTable from '../../table/MsTable';

import PageBase from '../../../app/PageBase';

import { WorkflowGetList } from '../../../redux/actions/tracker/workflowActions';

class WorkFlowList extends Component {

  constructor(props) {

    super(props);
    this.isSelected = this.isSelected.bind(this);
    this.state = {
      response: [],
      selected: [],
    };

  }

  componentWillMount() {

    const holdingID = this.props.user.context.idHolding;

    WorkflowGetList(holdingID).then((response) => {

      this.setState({ response });

    });

  }

  isSelected = wfid => null

  handleDeleteClick = wf => this.props.router.push(`/workflow/delete/${wf.workFlowId}`);

  handleCreateClick = () => this.props.history.push('/workflow/create/');

  render() {

    const { response } = this.state;

    return (
      <div>

        <PageBase title={I18n.t('menu.workflowList')}>
          <MsTable
            data={response}
            entryKey="workFlowId"
            paginate
            onPaginate={this.onPaginate}
            toolbar
            handleCreateClick={this.handleCreateClick}
            handleDeleteClick={this.handleDeleteClick}
            tableDef={[
              { name: 'workFlowId', label: 'Id' },
              { name: 'name', label: 'Nome' },
              { name: 'companyName', label: 'Empresa' },
            ]}
          />
        </PageBase>
      </div>
    );

  }

}

export default withRouter(WorkFlowList);



// WEBPACK FOOTER //
// ./src/components/tracker/WorkFlow/WorkFlowList.js